/* eslint-disable import/prefer-default-export */
import axios from 'axios'

export const apiAdmin = axios.create({
  baseURL: "https://recompensasrepuestosadmin.appengine.lucia.com.co",
  withCredentials: true,
  timeout: 960000,
  headers: {
    'Content-Type': 'application/json',
  },
})

